export default __webpack_public_path__ + "static/media/trash-icon.183a63e9.svg";